<template lang="pug">
.title-navigation
  .dawn-title-nav(:class='{ sticky }' ref='toolbar')
    .container
      .row
        .col-md-12
          .title-area
            h1.page-title {{ title }}
            p.page-subtitle(v-if='subtitle') {{ subtitle }}
          .overview-area.col-md-6(v-if='hasOverview')
            slot(name='overview')
          .tabs-area(v-if='hasTabs')
            slot(name='tabs')
              router-link(v-for='(tab, i) in tabs', :key='i', :to='tab.href', active-class='active')  {{ tab.label }}
          .action-area.text-right(v-if='hasAction')
            slot(name='action')
          .action-area.text-right(v-if='reference')
            router-link(:to='backReference')
              i.fa.fa-long-arrow-left
              span {{ $t('Back') }} {{ backReferenceTitle }}
    slot(name='toolbar')
  .sticky-placeholder(:style='{ height: $refs.toolbar && sticky ? `${$refs.toolbar.clientHeight}px` : 0 }')
</template>

<script>

export default {
  name: 'ed-title-nav',
  props: {
    title: String,
    subtitle: String,
    reference: Boolean,
    tabs: Array,
    fixed: { type: Boolean, default: true }
  },
  data () {
    return {
      sticky: this.fixed,
      backButton: false,
      backReference: '/' + this.$router.currentRoute.params.namespace + '/' + global.app.backReference
    }
  },
  methods: {
    navigateBack () {
      // function to go back a page
    },
    setSticky(e) {
      if (typeof this.breakPoint !== 'undefined') {
        this.sticky = e.target.scrollTop > this.breakPoint - 9
        if (this.sticky) {
          this.nextSibling && this.nextSibling.classList.add('sticky')
        } else {
          this.nextSibling && this.nextSibling.classList.remove('sticky')
        }
      }
    },
    getToolbar() {
      this.nextSibling = this.$el.nextElementSibling
      if (
        ~this.nextSibling.className.indexOf('toolbar') &&
        ~this.nextSibling.className.indexOf('sticky')
      ) {
        //
      } else {
        this.nextSibling = null
      }
    }
  },
  computed: {
    hasOverview() {
      return this.$slots.overview
    },
    hasAction() {
      return this.$slots.action
    },
    backToTitle() {
      return global.app.backReferenceTitle
    },
    hasTabs() {
      return this.$slots.tabs || this.tabs && this.tabs.length
    },
    backReferenceTitle() {
      return global.app.backReferenceTitle ? this.$t('to') + ' ' + this.$t(this.backToTitle) : ''
    }
  },
  mounted() {
    this.$refs.toolbar.classList.remove('sticky')
    if (this.fixed) {
      this.$nextTick(() => {
        this.breakPoint = this.$el.offsetTop + 5
      })
    }

    // this.getToolbar()

    let viewport = document.querySelector('.main-panel')
    viewport.removeEventListener('scroll', this.setSticky)
    viewport.addEventListener('scroll', this.setSticky)
  },
  destroyed() {
    let viewport = document.querySelector('.main-panel')
    viewport.removeEventListener('scroll', this.setSticky)
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.title-navigation {
  position: relative;
  z-index: 10000;
}

.dawn-title-nav >>> {
  .toolbar {
    margin-bottom: -5px;
  }
  .dawn-tab-nav-wrapper.wide {
    margin-bottom: -5px;
  }
  .dawn-tab-nav-wrapper .dawn-tab-nav.tabs {
    border-bottom: none;
  }
}

.sticky-placeholder {
  display: none;
}

.dawn-title-nav {
  //transition: all 0.3s ease;
  position: relative;
  z-index: 9999;
  padding-bottom: 4px;

  &.sticky {
    position: fixed;
    // padding-top: 9px;
    top: 0;
    left: -8.5px;
    z-index: 999999;
    box-shadow: $box-shadow;

    & + .sticky-placeholder {
      display: block;
    }
  }

  width: 100%;
  border-bottom: $border-default;
  @include theme() {
  border-color: v(background-light);
  background: v(canvas);
  }
  text-transform: none;
  // padding: .75rem $side-padding - .2rem .3rem;

  .title-area, .tabs-area, .action-area {
    display: inline-block;
  }
  .title-area, .tabs-area {
    vertical-align: middle;
  }

  .tabs-area {
    margin-left: 1em;
    line-height: 3em;
    @include theme() { border-left: 1px solid v(background) }

    a + a {
      padding-left: 1.2em;
      @include theme() {
        border-left: 1px solid v(border);
      }
    }

    a {
      @include soft-font;
      display: inline-block;
      margin-left: 1.2em;
      line-height: 1.2em;

      font-size: $font-size-large;
      text-decoration: none;

      @include theme() {
        & {
          color: v(border);
        }
        &:hover, &.router-link-exact-active {
          color: v(ink);
          font-weight: 600;
        }
      }

      &:first-child {
        //@include theme() { border-left: 1px solid v(background-light) }
      }
    }
  }
  .overview-area {
    float: right;
  }
  .overview-area {
    float: right;
  }

  .action-area {
    position: absolute;
    //top: -5px;
    left: 15px;

    float: right;
    text-transform: uppercase;
    font-size: $font-size-xsmall;
    font-weight: $font-weight-bold;
    line-height: 3;

    i {
      margin-right: .5rem;
    }

    a {
      @include theme() { color: v(ink) }

      &:hover {
        text-decoration: none;
        @include theme() { color: v(border) }
      }
    }
  }

  h1.page-title {
    margin: 0;
    padding-top: 1.2em;
    line-height: 1em;

    font-size: $font-size-xxlarge;
    font-weight: $font-weight-normal;
    font-family: $font-family-sans-serif;
  }

  p.page-subtitle {
    font-size: $font-size-base;
    font-weight: $font-weight-bold;
  }
}

</style>



// WEBPACK FOOTER //
// src/core/components/edTitleNav/index.vue